import { render, staticRenderFns } from "./CreateUserCompany.vue?vue&type=template&id=bc15d434&scoped=true"
import script from "./CreateUserCompany.vue?vue&type=script&lang=js"
export * from "./CreateUserCompany.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=bc15d434&prod&scoped=true&lang=css&external"
import style1 from "./CreateUserCompany.vue?vue&type=style&index=1&id=bc15d434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc15d434",
  null
  
)

export default component.exports